import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../../@shared/services/admin.service';
import { AdminDashboardStats } from '../../../../@shared/models/response.module';

@Component({
  selector: 'app-admin-dashboard',
  standalone: false,
  templateUrl: './admin-dashboard.html',
  styleUrl: './admin-dashboard.css'
})
export class AdminDashboard implements OnInit {
  loading: boolean = true;
  stats: AdminDashboardStats | null = null;

  constructor(private adminService: AdminService) {}

  ngOnInit() {
    this.loadStats();
  }

  loadStats() {
    this.loading = true;
    this.adminService.getDashboardStats().subscribe({
      next: (response) => {
        this.stats = response.data;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  getCompanyTypeLabel(type: string): string {
    const labels: { [key: string]: string } = {
      stable: 'Stables',
      riding_club: 'Riding Clubs',
      riding_school: 'Riding Schools',
      stores_services: 'Stores & Services',
      unspecified: 'Unspecified'
    };
    return labels[type] || type;
  }

  getCompanyCount(type: string): number {
    if (!this.stats) return 0;
    const byType = this.stats.companies.by_type as { [key: string]: number };
    return byType[type] || 0;
  }
}
